module.exports = __webpack_public_path__ + "img/wechat-mini.532e7196.png";